import { ca } from '@cian/analytics';

type TAction = 'Show_sopr' | 'Click_sopr';
type TSource = 'card_independent_banner_at_sidebar' | 'card_independent_banner_at_gallery';

export const trackDIYEntryPointShow = (source: TSource) => trackDIYEntryPointEvent('Show_sopr', source);
export const trackDIYEntryPointClick = (source: TSource) => trackDIYEntryPointEvent('Click_sopr', source);

function trackDIYEntryPointEvent(action: TAction, source: TSource) {
  ca('eventSite', {
    name: 'oldevent',
    action,
    category: 'Card',
    label: 'independent_banner',
    useLastProducts: true,
    page: {
      extra: {
        source,
      },
    },
  });
}
